import GiphyInsertModal from './toolbar/giphyInsertModal.js';
import 'react';
import './giphyApiInputModal-93a2c6e4.js';
import 'prop-types';
import 'wix-rich-content-common';
import 'wix-rich-content-ui-components';
import './style-inject.es-746bb8ed.js';
import './toolbar/giphySelector.js';
import 'react-infinite-scroller';
import 'react-md-spinner';
import 'react-custom-scrollbars';
import './constants.js';
import './giphyEmptyState-b0b6548c.js';
import './icons/PoweredByGiphy.js';
import 'classnames';
import 'lodash';
import './types.js';

const Modals = {
  GIPHY_API_INPUT: "giphy-api-input"
};
const ModalsMap = {
  [Modals.GIPHY_API_INPUT]: GiphyInsertModal
};

export { Modals, ModalsMap };
//# sourceMappingURL=modals.js.map
